import http from "@/http-common";

export default class MA601070Service {

	getList(_params) {
		return http.get('/ma/ma601070', { params: _params}).then(res => res.data);
	}

	selectLatestList(_params) {
		return http.get('/ma/ma601070/latest', { params: _params}).then(res => res.data);
	}

	getOne(_params) {
		//alert("_params = " + JSON.stringify(_params));
		return http.get('/ma/ma601070/getone', { params: _params}).then(res => res.data);
	}

	insertOne(_data) {
		//alert('_data = ' + JSON.stringify(_data));
		return http.post('/ma/ma601070',_data).then(res => res.data);
	}

	updateOne(_data) {
		return http.put('/ma/ma601070', _data).then(res => res.data);
	}

	// deleteOne(_data)
	// {
	// 	return http.delete('/ma/ma601070', _data).then(res => res.data);
	// }

	deleteOne( _data)
	{
		//alert('_data = ' + JSON.stringify(_data));
		return http.delete('/ma/ma601070', {data:JSON.stringify(_data)}).then(res => res.data);
	}

	insertOneFileList(_data, fileList) {
		let formData = new FormData(); 

		formData.append("ma601070", new Blob([JSON.stringify(_data)], { type: "application/json" }));
		
		fileList.forEach(function(file) {
			formData.append("fileList", file);
		});

		return http.post('/ma/ma601070/insertonefilelist', formData, {headers: {'Conent-Type': 'multipart/form-data'}}).then(res => res.data);
	}

	updateOneFileList(_data, fileList) {
		let formData = new FormData();

		formData.append("ma601070", new Blob([JSON.stringify(_data)], { type: "application/json" }));
		
		fileList.forEach(function(file) {
			formData.append("fileList", file);
		});

		return http.post('/ma/ma601070/updateonefilelist', formData, {headers: {'Conent-Type': 'multipart/form-data'}}).then(res => res.data);
	}

}

